import React from 'react';
import ActiviteEmptyState from '../ActiviteEmptyState';
import { ACTIVITE_TIMELINE_MVP_LIMIT } from '../../../utils/activite/activityTabs';

const TAB_COPY = {
  overview: {
    title: 'Timeline unifiée — HUB-G',
    description: `La vue d'ensemble agrégera ventes, caisse et stock (max ${ACTIVITE_TIMELINE_MVP_LIMIT} événements MVP). Contenu disponible au lot HUB-G.`,
  },
  ventes: {
    title: 'Ventes & tickets',
    description: 'Liste complète dans l\'onglet Ventes — voir HUB-B.1 à B.3.',
  },
  paiements: {
    title: 'Paiements — HUB-C',
    description: 'SumUp pending et historique Stripe/SumUp — lot HUB-C.',
  },
  caisse: {
    title: 'Caisse — HUB-D',
    description: 'Sessions caisse et vue mensuelle — lot HUB-D. /caisse-historique reste actif.',
  },
  stock: {
    title: 'Stock — HUB-E',
    description: 'Mouvements récents — lot HUB-E. /stock/mouvements reste actif.',
  },
  reparations: {
    title: 'Réparations — HUB-F',
    description: 'Liste compacte filtrée — lot HUB-F. /reparations reste actif.',
  },
  equipe: {
    title: 'Équipe — HUB-H',
    description: 'Journal audit (Carlos-only) — lot HUB-H.',
  },
};

export default function ActiviteShellTab({ tabId }) {
  const copy = TAB_COPY[tabId] || TAB_COPY.overview;
  return (
    <div data-testid={`activite-panel-${tabId}`}>
      <ActiviteEmptyState
        title={copy.title}
        description={copy.description}
        testId={`activite-empty-${tabId}`}
      />
    </div>
  );
}
